import { createAction, handleActions } from 'redux-actions'
import api from '../api'
import moment from 'moment'
import { act } from 'react-dom/test-utils'

export const GET_HYLTESIM_API_STATUS = createAction('admin/healthz/CHECK')
export const GET_HYLTESIM_API_STATUS_SUCCESS = createAction('admin/healthz/CHECK_SUCCESS')
export const GET_HYLTESIM_API_STATUS_ERROR = createAction('admin/healthz/CHECK_ERROR')

export const GET_TELIA_STATUS = createAction('admin/GET_TELIA_STATUS')
export const GET_TELIA_STATUS_SUCCESS = createAction('admin/GET_TELIA_STATUS_SUCCESS')
export const GET_TELIA_STATUS_ERROR = createAction('admin/GET_TELIA_STATUS_ERROR')

export const GET_AZURE_STATUS = createAction('admin/GET_AZURE_STATUS')
export const GET_AZURE_STATUS_SUCCESS = createAction('admin/GET_AZURE_STATUS_SUCCESS')
export const GET_AZURE_STATUS_ERROR = createAction('admin/GET_AZURE_STATUS_ERROR')

export const GET_JOB_STATUS = createAction('admin/GET_JOB_STATUS')
export const GET_JOB_STATUS_SUCCESS = createAction('admin/GET_JOB_STATUS_SUCCESS')
export const GET_JOB_STATUS_ERROR = createAction('admin/GET_JOB_STATUS_ERROR')

export const GET_METRICS = createAction('admin/GET_METRICS')
export const GET_METRICS_SUCCESS = createAction('admin/GET_METRICS_SUCCESS')
export const GET_METRICS_ERROR = createAction('admin/GET_METRICS_ERROR')

export const GET_JETSHOP_STATUS = createAction('admin/GET_JETSHOP_STATUS')
export const GET_JETSHOP_STATUS_SUCCESS = createAction('admin/GET_JETSHOP_STATUS_SUCCESS')
export const GET_JETSHOP_STATUS_ERROR = createAction('admin/GET_JETSHOP_STATUS_ERROR')

export const SET_FILTER = createAction('admin/SET_FILTER')

const initialState = {
  loading: false,
  jetshopApiStatus: false,
  teliaApiStatus: false,
  azureApiStatus: false,
  hylteApiStatus: false,
  jobStatus: [],
  metrics: [],
  filter: {
    from: moment().subtract(30,'days').format("YYYY-MM-DD"),
    to: moment().format("YYYY-MM-DD"),
    orderBy: 0
  },
  error: null
}

export default handleActions(
  {
    [GET_JETSHOP_STATUS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_JETSHOP_STATUS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      jetshopApiStatus: true
    }),
    [GET_JETSHOP_STATUS_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      jetshopApiStatus: false
    }),
    [GET_HYLTESIM_API_STATUS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_HYLTESIM_API_STATUS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      hylteApiStatus: true
    }),
    [GET_HYLTESIM_API_STATUS_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      hylteApiStatus: false
    }),
    [GET_TELIA_STATUS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_TELIA_STATUS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      teliaApiStatus: true
    }),
    [GET_TELIA_STATUS_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      teliaApiStatus: false
    }),
    [GET_AZURE_STATUS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_AZURE_STATUS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      azureApiStatus: true
    }),
    [GET_AZURE_STATUS_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      azureApiStatus: false
    }),
    [GET_JOB_STATUS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_JOB_STATUS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      jobStatus: action.payload
    }),
    [GET_JOB_STATUS_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      jobStatus: action.payload
    }),
    [GET_METRICS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_METRICS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      metrics: action.payload
    }),
    [SET_FILTER]: (state, action) => {
      let filter = state.filter
      filter[action.payload.name] = action.payload.value
      return {...state, filter}
    },
    [GET_METRICS_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      metrics: action.payload
    })
  },
  initialState
)

export const getJetshopApiStatus = () => {
  return dispatch => {
    dispatch(GET_JETSHOP_STATUS())
    return api
      .get('admin/GenzoShopStatus')
      .then(result => {
        dispatch(GET_JETSHOP_STATUS_SUCCESS())
      })
      .catch(error => {
        dispatch(GET_JETSHOP_STATUS_ERROR())
      })
  }
}

export const getHyltesimApiStatus = () => {
  return dispatch => {
    dispatch(GET_HYLTESIM_API_STATUS())
    return api.get('healthz/check')
              .then(result => {
                dispatch(GET_HYLTESIM_API_STATUS_SUCCESS())
              })
              .catch(error => {
                dispatch(GET_HYLTESIM_API_STATUS_ERROR())
              })
  }
}

export const getJetshopStatus = () => {
  return dispatch => {
    dispatch(GET_HYLTESIM_API_STATUS())
    return api.get('healthz/check')
              .then(result => {
                dispatch(GET_HYLTESIM_API_STATUS_SUCCESS())
              })
              .catch(error => {
                dispatch(GET_HYLTESIM_API_STATUS_ERROR())
              })
  }
}

export const getTeliaApiStatus = () => {
  return dispatch => {
    dispatch(GET_TELIA_STATUS())
    return api
      .get('admin/teliaApiStatus')
      .then(result => {
        dispatch(GET_TELIA_STATUS_SUCCESS())
      })
      .catch(error => {
        dispatch(GET_TELIA_STATUS_ERROR())
      })
  }
}

export const getAzureApiStatus = () => {
  return dispatch => {
    dispatch(GET_AZURE_STATUS())
    return api
      .get('admin/azureApiStatus')
      .then(result => {
        dispatch(GET_AZURE_STATUS_SUCCESS())
      })
      .catch(error => {
        dispatch(GET_AZURE_STATUS_ERROR())
      })
  }
}

export const getJobStatus = () => {
  return dispatch => {
    dispatch(GET_JOB_STATUS())
    return api
      .get('admin/jobStatus')
      .then(result => {
        dispatch(GET_JOB_STATUS_SUCCESS(result))
      })
      .catch(error => {
        dispatch(GET_JOB_STATUS_ERROR(error))
      })
  }
}

export const getMetrics = (filter) => {
  if(!filter)
    filter = initialState.filter
  return dispatch => {
    dispatch(GET_METRICS())
    return api
      .get('admin/metrics', '', `From=${filter.from}&To=${filter.to}&OrderBy=${filter.orderBy}`)
      .then(result => {
        dispatch(GET_METRICS_SUCCESS(result))
      })
      .catch(error => {
        dispatch(GET_METRICS_ERROR(error))
      })
  }
}

export const setFilter = (name, value) => {
  return dispatch => {
    dispatch(SET_FILTER({ name, value }))
  }
}




// WEBPACK FOOTER //
// ./src/store/admin/index.js